/**
 * Mixin za formatiranje warehouse podataka
 */
import { SHIFT_KEYS } from "@/constants/warehouse";

export default {
  methods: {
    /**
     * Formatira količinu za prikaz
     * @param {number|string} val - Vrednost za formatiranje
     * @returns {string} - Formatirana količina
     */
    formatQuantity(val) {
      if (val == null) return "";
      return parseFloat(Number(val).toFixed(3)).toString();
    },

    /**
     * Izračunava količinu stavke na osnovu izabranih smena
     * @param {Object} item - Warehouse item
     * @param {Array<number>} selectedShifts - Niz izabranih smena [1,2,3,4]
     * @returns {number} - Ukupna količina
     */
    calculateItemQuantity(item, selectedShifts) {
      if (this.filters.showType === "daily") {
        return parseFloat(item.quantity || 0);
      }

      return selectedShifts
        .filter((shift) => shift >= 1 && shift <= 4)
        .reduce(
          (sum, shift) => sum + parseFloat(item.shift?.[SHIFT_KEYS[shift - 1]] || 0),
          0
        );
    },

    /**
     * Formatira shift podatke za štampanje/export
     * @param {Object} shift - Shift objekat sa podacima
     * @returns {Object|undefined} - Formatiran shift objekat
     */
    formatShiftData(shift) {
      if (!shift) return undefined;

      return SHIFT_KEYS.reduce((acc, key) => {
        acc[key] = parseFloat(shift[key] || 0).toFixed(3);
        return acc;
      }, {});
    },

    /**
     * Formatira stavku za štampanje/export
     * @param {Object} item - Warehouse item
     * @param {number} index - Redni broj
     * @returns {Object} - Formatiran objekat za štampanje
     */
    formatItemForPrint(item, index) {
      return {
        num: index + 1,
        code: item.code,
        name: item.name,
        measure: item.measure,
        quantity: item.quantityWithMeasure,
        stock: parseFloat(item.stock || 0).toFixed(2),
        order: parseFloat(item.order || 0).toFixed(3),
        ordered: parseFloat(item.ordered || 0).toFixed(3),
        shift: this.formatShiftData(item.shift),
        stockWithMeasure: item.stockWithMeasure,
      };
    },
  },
};
